import React from 'react';
import { BusinessJobResponse } from '../models';
import { Grid } from '@mui/material';
import { BusinessSlot, ShiftMatch, ShiftJob, ShiftProvider } from 'models';
import { format12HourTime } from 'shared/Dates';
import { TitleDescription } from './TitleDescription';
import { MatchStatusChips } from '../../BusinessCalendar/ShiftCard/MatchStatusChips';
import { getShiftTimes } from '../../BusinessCalendar/ShiftCard/shiftTimesUtils';
import { EditPay } from '../../BusinessCalendar/ShiftCard/EditPay';

export function BusinessSlotSchedule({
    slot,
    job,
    provider,
    recruitmentStatuses,
    refresh,
}: {
    slot: BusinessSlot;
    job: BusinessJobResponse['job_details'] | ShiftJob;
    provider?: ShiftProvider;
    recruitmentStatuses: { title: string; show: boolean }[];
    refresh: () => void;
}) {
    const recruitmentStatus = recruitmentStatuses.find((s) => s.show)?.title ?? 'Shift Posted';
    const matches = slot.appointments.reduce((x: ShiftMatch[], appt) => [...x, ...(appt.matches ?? [])], []);
    const { shiftStart, shiftEnd, infoText } = getShiftTimes(slot);
    const timezone = job.timezone;
    const workerPay = provider?.pay;
    return (
        <Grid item container alignItems="flex-end" direction="row" style={{ marginTop: 5, gap: 20 }}>
            <TitleDescription
                title={'Schedule'}
                description={`${format12HourTime(shiftStart, timezone)} - ${format12HourTime(shiftEnd, timezone, true)}`}
                infoText={infoText}
            />
            <TitleDescription
                title={job.pay || workerPay ? 'Pay' : 'Pay Scale'}
                description={
                    job.pay || workerPay ? `$${workerPay ?? job.pay}/hr` : `$${job.rate_min} - ${job.rate_max}/hr`
                }
            />
            <EditPay
                visible={!!provider}
                pay={workerPay}
                jobId={job.id}
                provider={provider?.provider}
                refresh={refresh}
            />
            {provider ? null : <TitleDescription title="Confirmed Worker" description={recruitmentStatus} />}
            <MatchStatusChips matches={matches} />
        </Grid>
    );
}
